// Unit Master RA images are served from the Lease Finance backend
// (leasefinanceapi.apps.pro360erp.com/Resources/...), not the main
// REACT_APP_IMAGE_URL host used elsewhere in this app. Rows saved before the
// backend's UploadSettingsRA config was actually wired up also carry a
// fullUrl baked against http://localhost:5000 (that class's hardcoded
// default, never bound to real config) - this rewrites either case to the
// real live host so already-saved rows work without needing a DB fix.
const LEASE_FINANCE_IMAGE_URL = (process.env.REACT_APP_BACKEND_URL_LeaseFinance || '').replace(/\/+$/, '');
const LOCALHOST_ORIGIN_PATTERN = /^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?/i;

export const rewriteUnitRAImageUrl = (url) => {
  if (!url || !LEASE_FINANCE_IMAGE_URL || !LOCALHOST_ORIGIN_PATTERN.test(url)) return url;
  try {
    const targetOrigin = new URL(LEASE_FINANCE_IMAGE_URL).origin;
    return url.replace(LOCALHOST_ORIGIN_PATTERN, targetOrigin);
  } catch {
    return url;
  }
};
